import React, { ReactNode } from 'react'
import BaseModal from './base-modal';

interface Props {
    children: ReactNode;
    open: boolean;
    title: string;
    onClose: () => void;
}

export default function DeleteModal(props: Props) {
    const { open, title, onClose } = props;

    return <BaseModal open={open} title={`Delete ${title}`} onClose={onClose} successTitle='Delete'>
        {props.children}
    </BaseModal>
}